import { render, staticRenderFns } from "./subContractCost.vue?vue&type=template&id=2ca94a0b&scoped=true&"
import script from "./subContractCost.vue?vue&type=script&lang=js&"
export * from "./subContractCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca94a0b",
  null
  
)

export default component.exports